var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.9583C5.05817 18.9583 1.0415 14.9416 1.0415 9.99996C1.0415 5.05829 5.05817 1.04163 9.99984 1.04163C14.9415 1.04163 18.9582 5.05829 18.9582 9.99996C18.9582 14.9416 14.9415 18.9583 9.99984 18.9583ZM9.99984 2.29163C5.74984 2.29163 2.2915 5.74996 2.2915 9.99996C2.2915 14.25 5.74984 17.7083 9.99984 17.7083C14.2498 17.7083 17.7082 14.25 17.7082 9.99996C17.7082 5.74996 14.2498 2.29163 9.99984 2.29163Z",
    fill: "#0085FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8167 12.9833C8.65003 12.9833 8.4917 12.9166 8.37503 12.8L6.0167 10.4416C5.77503 10.2 5.77503 9.79996 6.0167 9.55829C6.25837 9.31663 6.65837 9.31663 6.90003 9.55829L8.8167 11.475L13.1 7.19163C13.3417 6.94996 13.7417 6.94996 13.9834 7.19163C14.225 7.43329 14.225 7.83329 13.9834 8.07496L9.25837 12.8C9.1417 12.9166 8.98337 12.9833 8.8167 12.9833Z",
    fill: "#0085FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.feefade7bd2ef0756377034e07752776.svg";
export { ForwardRef as ReactComponent };